import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { ErrorState } from '@leanin/ui';
import { RetryButton } from '@/components/states/index';
import { moderationKeys } from '@/lib/queries/moderation';
import { AutoHideNoticeView } from './-components/AutoHideNoticeView';

export const Route = createFileRoute(
  '/_authed/moderation/auto-hide-notice/$holdId/',
)({
  component: AutoHideNoticePage,
});

function AutoHideNoticePage() {
  const { holdId } = Route.useParams();
  const query = useQuery({
    ...moderationKeys.hold(holdId),
    retry: false,
  });

  if (query.isLoading) return null;
  if (query.isError) {
    const status = (query.error as { status?: number })?.status;
    const isNotFound = status === 404;
    return (
      <ErrorState
        title="We couldn't load that hold."
        body={
          isNotFound
            ? "We can't find this hold, or it doesn't belong to your account."
            : "Something on our end didn't respond. Give it a moment and try again."
        }
        reference={isNotFound ? 'http_404' : 'http_500'}
        {...(isNotFound ? {} : { primary: <RetryButton /> })}
      />
    );
  }
  return <AutoHideNoticeView holdId={holdId} />;
}
